// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export interface PaykuDepositPayload {
  amount: number | string;
  currency: string;
  paymentMethod: number;
}

export interface PaykuWithdrawalPayload {
  amount: number | string;
  currency: string;
  beneficiaryName: string;
  email: string;
  phone: string;
  accountbank_name: string;
  accountbank_rut: string;
  accountbank_sbif: string;
  accountbank_type: number;
  accountbank_num: string;
}

export const postPaykuDeposit = async (depositData: PaykuDepositPayload) => {
  return await privateRequest.post(`${ConfEnv.API_WALLET.URL_PAYKU_DEPOSIT}`, {
    amount: depositData.amount.toString(),
    currency: depositData.currency,
    payment_method: depositData.paymentMethod,
  });
};

export const getPaykuTransactionStatus = async (orderId: string) => {
  return await privateRequest.get(`${ConfEnv.API_WALLET.URL_PAYKU_TRANSACTION_STATUS}/${encodeURIComponent(orderId)}`);
};

export const postPaykuWithdrawal = async (withdrawalData: PaykuWithdrawalPayload) => {
  return await privateRequest.post(`${ConfEnv.API_WALLET.URL_PAYKU_WITHDRAWAL}`, {
    amount: withdrawalData.amount,
    currency: withdrawalData.currency,
    beneficiaryName: withdrawalData.beneficiaryName,
    email: withdrawalData.email,
    phone: withdrawalData.phone,
    accountbank_name: withdrawalData.accountbank_name,
    accountbank_rut: withdrawalData.accountbank_rut,
    accountbank_sbif: withdrawalData.accountbank_sbif,
    accountbank_type: withdrawalData.accountbank_type,
    accountbank_num: withdrawalData.accountbank_num,
    provider: "payku",
  });
};

export const getPaykuBanks = async (currency: string) => {
  return await privateRequest.get(`${ConfEnv.API_WALLET.URL_PAYKU_BANKS}/${encodeURIComponent(currency)}`);
};
